// extracted by mini-css-extract-plugin
export default {"tablehead":"TransportDataTable_tablehead__FuoNc","custom-striped-table":"TransportDataTable_custom-striped-table__A5e1K"};